import React from 'react';
import { Link } from 'react-router-dom';
import { PageShell } from '../components/Ui';

/** Public privacy policy — required for Google Play listing. */
export default function PrivacyPolicyPage() {
  return (
    <div className="page" style={{ maxWidth: 720, margin: '0 auto', padding: '24px 16px 48px' }}>
      <PageShell title="Privacy Policy" subtitle="HCEN Networks Hospital HMS (Android & Web)">
        <div className="card" style={{ lineHeight: 1.6, fontSize: 14, color: '#334155' }}>
          <p><strong>Effective date:</strong> 18 July 2026</p>
          <p>
            HCEN Networks (“we”, “us”) provides hospital staff software for clinical and administrative workflows.
            This policy explains how the HCEN Networks app and website handle information.
          </p>
          <h3>Who the app is for</h3>
          <p>
            The app is for authorised hospital staff and HCEN platform administrators only.
            It is not a consumer / patient booking app.
          </p>
          <h3>Data we process</h3>
          <ul>
            <li>Staff account details (name, email, role, hospital assignment)</li>
            <li>Clinical and operational records entered by staff (patients, visits, bills, lab, pharmacy, IPD, etc.)</li>
            <li>Device / session data needed for security (login tokens, optional IP for lockout)</li>
          </ul>
          <h3>How we use data</h3>
          <p>
            Data is used only to run hospital operations for the logged-in hospital, enforce roles,
            and improve reliability/security of the service. We do not sell personal data.
          </p>
          <h3>Storage & security</h3>
          <p>
            Data is stored on secured cloud infrastructure (AWS). Access is protected by authentication,
            role checks, and hospital scoping. Staff must keep passwords confidential.
          </p>
          <h3>Sharing</h3>
          <p>
            Hospital data stays with that hospital’s account, except where the hospital enables optional
            integrations (e.g. SMS gateway, ABDM sandbox, AI assist) under their control.
          </p>
          <h3>Your rights</h3>
          <p>
            Hospital managers / HCEN admins can update or deactivate staff accounts.
            Contact your hospital administrator or HCEN support for data requests.
          </p>
          <h3>Contact</h3>
          <p>
            Email: <a href="mailto:support@hcen.in">support@hcen.in</a><br />
            Web: <a href="https://networks.hcen.in">https://networks.hcen.in</a>
          </p>
          <p style={{ marginTop: 24 }}>
            <Link to="/login">← Back to staff login</Link>
          </p>
        </div>
      </PageShell>
    </div>
  );
}
